module.exports = "<div>\n        <ng-transclude></ng-transclude>\n</div>"